import React from 'react'
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useKeyDown } from '../../../hooks/useKeyDown';
import IlloPiggy from '../../../assets/kudzu-plus-images/add-money-modal.png'
     
const AddMoneyPopover = ({ content1, btn1, btn1Function, btn2, btn2Function, icon = false }) => {
   
    useKeyDown(() => {
        btn1Function();
    }, ["Enter"])
   

    return (
        <div className=' flex flex-col justify-center items-center w-full'>
            <p className={`font-hanken-grotesk lg:text-[19px] md:text-[19px] sm:text-[16px] ${icon ? "mb-0" : "mb-44"} text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-[#ffffff]`}>{content1}</p>
            {icon ? (<img src={IlloPiggy} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />)
                :
                (<></>)
            }
            <div className=' flex flex-col justify-center items-center w-full'>


                <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                    <button type="button" className="font-hanken-grotesk lg:text-[18px] md:text-[17px]
                                   sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                        onClick={btn1Function}>{btn1}</button>


                    {btn2 &&
                        <button type="button" className={`font-hanken-grotesk lg:text-[18px] md:text-[17px]
                                        sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px]  cursor-pointer  px-2
                                        py-4 ${icon ? " text-[#94c3e8]" : "border-[#2965FB] sm:border-none text-[var(--modal-btn-text-color)]"}  w-full capitalize`}
                            onClick={() => btn2Function()} onKeyDown={(e) => { if (e.key === "Enter") btn2Function() }}>{btn2}</button>
                    }


                </div>
            </div>


        </div>
    )
}


export default withOidcSecure(AddMoneyPopover)

